define('v3/Common/Services/learningObjectiveStatusService',[
	'jquery',
	'v3/Common/Services/Backend/learningObjectiveStatusBackend',
	'v3/Common/Models/enums'
], function (
	$,
	backend,
	enums
) {
	return {
		/**
		* Get learningobjective statuses for the given lo's for a single pupil
		* One pupil to many lo's
		* @param {number} classId
		* @param {number} subjectGroupId
		* @param {number} pupilId
		* @param {number[]} learningObjectiveIds
		*/
		getLearningObjectiveStatusesForPupil: function (classId, subjectGroupId, pupilId, learningObjectiveIds, ignoreErrors) {
			return backend.getLearningObjectiveStatusesForPupil(classId, subjectGroupId, pupilId, learningObjectiveIds, ignoreErrors);
		},

		getLearningObjectiveStatusesWithLegacyPropertyForPupil: function (classId, subjectGroupId, pupilId, learningObjectiveIds, ignoreErrors) {
			return backend.getLearningObjectiveStatusesForPupil(classId, subjectGroupId, pupilId, learningObjectiveIds, ignoreErrors)
				.then(function (data) {
					for (var i = 0; i < data.length; i++) {
						data[i].state = createLegacyStatus(data[i].learningObjectiveProgressStatus);
					}
					return data;
				});
		},

		hasEnoughAnswersForLearningObjectiveStatus: function (classId, subjectGroupId, learningObjectiveIds, ignoreErrors) {
			return backend.hasEnoughAnswersForLearningObjectiveStatus(classId, subjectGroupId, learningObjectiveIds, ignoreErrors);
		},

		/**
		* Get statuses for a given set of pupils for a single learningobjective
		* One lo to many pupils
		* @param {number} classId
		* @param {number} subjectGroupId
		* @param {number} learningObjectiveId
		* @param {number[]} pupilIds
		*/
		getPupilsStatusesForLearningObjective: function (classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors) {
			return backend.getPupilsStatusesForLearningObjective(classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors);
		},

		getPupilsStatusesWithLegacyPropertyForLearningObjective: function (classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors) {
			return backend.getPupilsStatusesForLearningObjective(classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors)
				.then(function (data) {
					for (var i = 0; i < data.length; i++) {
						data[i].state = createLegacyStatus(data[i].learningObjectiveProgressStatus);
					}
					return data;
				});
		},

		getPupilsWithStatusCountsForLearningObjective: function (classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors) {
			return backend.getPupilsWithStatusCountsForLearningObjective(classId, subjectGroupId, learningObjectiveId, pupilIds, ignoreErrors);
		},

		/**
		* Get statuses for a given set of pupils per learningobjective
		* Many lo's to many pupils
		* @param {number} classId
		* @param {number} subjectGroupId
		* @param { { learningObjectiveId: number, pupilIds: number[] }[] } pupilIdsPerLOArray This is an
		* array containg objects with a loId and an array of pupilIds for that lo
		* @returns an object where the key is the learningobjective and the value is an array containing pupilIds an statuses
		*/
		getPupilsStatusesForLearningObjectives: function (classId, subjectGroupId, pupilIdsPerLOArray, ignoreErrors) {
			var pupilsStatusesForLearningObjective = pupilIdsPerLOArray.map(function (pupilIdsPerLO) {
				return backend.getPupilsStatusesForLearningObjective(
					classId,
					subjectGroupId,
					pupilIdsPerLO.learningObjectiveId,
					pupilIdsPerLO.pupilIds,
					ignoreErrors
				);
			});

			return $.when
				.apply($, pupilsStatusesForLearningObjective)
				.then(function () {
					var results = {};
					for (var index in arguments) {
						if (arguments[index] && arguments[index].hasErrors) {
							return { hasErrors: true };
						}

						if (arguments[index] && arguments[index][0]) {
							var learningObjectiveId = arguments[index][0].learningObjectiveId;

							results[learningObjectiveId] = {};

							arguments[index].forEach(function (pupilStatus) {
								results[learningObjectiveId][pupilStatus.userId] = createLegacyStatus(pupilStatus.learningObjectiveProgressStatus);
							});
						}
					}
					return results;
				});
		},

		getSubjectGroupStatus: function (shouldCalculateStatus, numberOfPupils) {
			if (!shouldCalculateStatus) {
				return enums.learningObjectiveState.notStarted;
			}

			var pupilsInTotal = numberOfPupils.notStarted +
				numberOfPupils.stuck +
				numberOfPupils.inProgress +
				numberOfPupils.finished;

			var state = (numberOfPupils.finished / pupilsInTotal >= 0.8)
				? enums.learningObjectiveState.finished
				: enums.learningObjectiveState.inProgress;

			return state;
		},

		getNumberOfPupilsBehindTheClass: function (subjectGroupStatus, numberOfPupils) {
			if (subjectGroupStatus === enums.learningObjectiveState.finished) {
				return numberOfPupils.notStarted + numberOfPupils.stuck + numberOfPupils.inProgress;
			} else if (subjectGroupStatus === enums.learningObjectiveState.inProgress) {
				return numberOfPupils.notStarted + numberOfPupils.stuck;
			}

			return 0;
		},

		getLoStatusCountForLoIds: function (classId, subjectGroupId, learningObjectiveIds, userIds, ignoreErrors) {
			return backend.getLoStatusCountForLoIds(classId, subjectGroupId, learningObjectiveIds, userIds, ignoreErrors);
		}
	};

	function createLegacyStatus (status) {
		switch (status) {
		case 'preliminaryProgress':
			return enums.learningObjectiveState.preliminaryProgress;
		case 'stuck':
			return enums.learningObjectiveState.stuck;
		case 'inProgress':
			return enums.learningObjectiveState.inProgress;
		case 'finished':
			return enums.learningObjectiveState.finished;
		default:
			return enums.learningObjectiveState.notStarted;
		}
	}
});
